import http from '@/plugins/axios/axios';

export default class LoginService {

    autenticar(usuario) {
        return http.post('/api/login/aut-usuario', usuario);
    }

    validarToken(usuario) {
        return http.post('/api/login/validar-token', usuario);
    }

    solicitarRedefinirSenha(usuario) {
        return http.post('/api/login/solicitar-redefinir-senha', usuario);
    }

    redefinirSenha(usuario) {
        return http.post('/api/login/redefinir-senha', usuario);
    }
}